/**
 * Placeholder rows for the announcements screen.
 *
 * There is no announcement endpoint on the API yet. The screen ships so the
 * shape of the feature is agreed before it is built, and every row is rendered
 * under `SampleNotice`, which states that nothing here is live data.
 * Labels are i18n keys, resolved by the page.
 */
export interface SampleAnnouncement {
  id: string;
  subjectKey: string;
  audienceKey: string;
  channelKey: string;
  sendAt: string;
  statusKey: string;
  reach: number;
}

export const SAMPLE_ANNOUNCEMENTS: readonly SampleAnnouncement[] = [
  {
    id: 'sample-1',
    subjectKey: 'announcements.samples.challenge',
    audienceKey: 'announcements.audience.everyone',
    channelKey: 'announcements.channels.push',
    sendAt: '2026-01-02T09:00:00Z',
    statusKey: 'status.sent',
    reach: 18240,
  },
  {
    id: 'sample-2',
    subjectKey: 'announcements.samples.digest',
    audienceKey: 'announcements.audience.active',
    channelKey: 'announcements.channels.email',
    sendAt: '2026-01-09T07:30:00Z',
    statusKey: 'status.scheduled',
    reach: 9120,
  },
  {
    id: 'sample-3',
    subjectKey: 'announcements.samples.commission',
    audienceKey: 'announcements.audience.affiliates',
    channelKey: 'announcements.channels.inApp',
    sendAt: '2026-01-15T12:00:00Z',
    statusKey: 'status.draft',
    reach: 0,
  },
];
